import { acceptHMRUpdate, defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';

export const useOrderStore = defineStore('order', () => {
    const all = ref({ data: [] });

    const active = ref({});

    const cart = ref([]);

    const price = ref({});

    const reset = () => {
        all.value = { data: [] };
    };

    const search = (params) => {
        return axios.get('/api/v1/orders', { params });
    };

    const store = (params) => {
        return axios.post('/api/v1/orders', params);
    };

    const update = (params) => {
        return axios.patch('/api/v1/orders/' + params.hash, params);
    };

    const destroy = (params) => {
        return axios.delete('/api/v1/orders/' + params.hash);
    };

    const submit = (params) => {
        return axios.post('/api/v1/orders/submit', params);
    };

    const calculate = (params) => {
        return axios.post(`/api/v1/orders/${params.pharmacy_hash}/calculate`, params);
    };

    const reorder = async (orderHash) => {
        const response = await axios.post(`/api/v1/orders/${orderHash}/reorder`);
        return response.data.order;
    };

    const convertQuote = (params) => {
        return axios.post(`/api/v1/orders/${params.hash}/convert-quote`);
    };

    return {
        all,
        reset,
        search,
        store,
        update,
        destroy,
        active,
        cart,
        submit,
        calculate,
        price,
        reorder,
        convertQuote,
    };
});

// HMR
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useOrderStore, import.meta.hot));
}
